import { createReducer } from '@reduxjs/toolkit'
import { setFilterPacks, setImageElement, updateFilterPackById } from './actions'

const initialState: any = {
  imageElements: [],
  filterPacks: []
}

export const imageElementsReducer = createReducer(initialState, builder => {
  builder.addCase(setImageElement, (state, { payload }) => {
    state.imageElements = payload
  })
  builder.addCase(setFilterPacks, (state, { payload }) => {
    state.filterPacks = payload
  })
  builder.addCase(updateFilterPackById, (state, { payload }) => {
    const filterPack = state.filterPacks.find((pack: any) => pack.id === payload.packId)
    if (filterPack) {
      state.filterPacks = state.filterPacks.map((pack: any) => {
        if (pack.id === payload.packId) {
          return {
            ...pack,
            ...payload.data
          }
        }
        return pack
      })
    }
  })
})
